import { Component, OnInit, input } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Router } from '@angular/router';
import { ADPResourceService } from 'digital-core';


@Component({
    selector: "adp-image",
    templateUrl: "./adp-image.component.html",
    styleUrls: ['./adp-image.component.scss'],
    imports: []
})

export class ADPImageComponent implements OnInit {
  readonly imageKey = input<string>(undefined);
  readonly imageClass = input<string>(undefined);
  readonly imageAlt = input<string>(undefined);
  transformedSpanContent: SafeHtml = '';
  transformedImgContent = '';
  transformedImageAlt = '';
  public constructor(
    public resourcesService: ADPResourceService,
    private router: Router,
    private domSanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    if (this.resourcesService.getPortalImage(this.imageKey()).ImageContent == "") {
      this.transformedImgContent = this.resourcesService.getPortalImage(this.imageKey()).ImageURL;
    } else {
      this.transformedSpanContent = this.domSanitizer.bypassSecurityTrustHtml(this.resourcesService.getPortalImage(this.imageKey()).ImageContent);
    }
    const imageAlt = this.imageAlt();
    if(imageAlt)
      this.transformedImageAlt = imageAlt ?? this.imageKey();
    else
      this.transformedImageAlt = this.resourcesService.getPortalImage(this.imageKey())['Caption'];
  }
}
